export function displayPhone(value) {
  if(value===null||value===undefined||String(value).trim()==='')return '—';
  const original=String(value).trim();
  if(!/^[+\d\s().-]+$/.test(original))return original;
  let digits=original.replace(/\D/g,'');
  if(digits.startsWith('00598'))digits=digits.slice(5);
  else if(digits.startsWith('598'))digits=digits.slice(3);
  else if(original.startsWith('+'))return original;
  if(/^9\d{7}$/.test(digits))digits='0'+digits;
  return /^09\d{7}$/.test(digits)?digits.replace(/(\d{3})(\d{3})(\d{3})/,'$1 $2 $3'):original;
}
